import React from "react";
import Login from "../_components/auth/Login";

function Auth() {
  return <Login />;
}

export default Auth;
